import { useEffect } from "react";
import Banner from "../components/Currencies/Banner";
import Cards from "../components/Currencies/Cards";
import WhyArvest from "../components/Home/WhyArvest";
import ArvestOffers from "../components/Home/ArvestOffers";
import NeedHelp from "../components/Accounts/NeedHelp";

function Currencies() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-[#EFEFEF] relative overflow-hidden">
            <Banner />
            <Cards />
            <WhyArvest />
            <ArvestOffers />
            <NeedHelp />
        </div>
    );
}

export default Currencies;
